import React from "react";
import { useTranslation } from "react-i18next";
import noSearchImg from "src/assets/images/blog/no-search-results.png";
import { noSearchResultsTrns } from "./trns";

export const NoSearchResults = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-4">
      <div className="min-w-25 min-h-25">
        <img
          className="w-full h-full"
          src={noSearchImg}
          alt="Nothing has been found for your request yet"
        />
      </div>

      <div>
        <h3 className="font-bold">
          {t(noSearchResultsTrns.title)}
        </h3>

        <p className="mt-4">
          {t(noSearchResultsTrns.subtitle)}
        </p>
      </div>
    </div>
  );
};
